(($, Drupal, drupalSettings) => {
  const timeBooker = function(el){
    this.el = el;
    this.init();
  }
  timeBooker.prototype = {
    init: function(){
      this.assisDent = new Drupal.assisDentCaller();
      this._addEventListeners();
      this.branch = this._getBranch();
      this.serviceSelect = this.el.querySelector('.service-select');
      this.userSelect =  this.el.querySelector('.user-select');
    },

    _addEventListeners: function(){
      var send = this.el.querySelector('.book');
      send.addEventListener('click', this._goToApoitment.bind(this));
    },

    _getBranch: function(){
      var officedata = document.querySelector('.node.node--view-mode-header');
      if( officedata && officedata.dataset.branchUuid){
        return officedata.dataset.branchUuid;
      }
      var possibleBranchSelector = this.el.querySelector('.branch-select');
      if( possibleBranchSelector ){
        possibleBranchSelector.addEventListener('change', e => {
          this.branch = e.target.value;
        });
      }
      return '';
    },

    _goToApoitment: function( e ){
      const a = document.createElement("a")
      a.href = this.assisDent.getBaseUrlForAppoitment(this.branch, this.userSelect.value, this.serviceSelect.value);
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click()
    }
  }
  Drupal.behaviors.timeBooking = {
    attach: (context, settings) => {
      // $(context.querySelectorAll('.office-booking')).once('timebooking').each( (index, bookingGroup) => {
      $(once('timebooking', '.office-booking')).each( (index, bookingGroup) => {
        new timeBooker(bookingGroup);
      });
    }
  }

})(jQuery, Drupal, drupalSettings);
